/**
 * Keeper® Password Manager & Digital Vault
 *
 * A password manager exposing its autofill prompt UI to every origin, not just to sites it fills on.
 *
 * Behavioural discovery (tooling/batch-interactions.js) found no usable page-side
 * marker for this extension, so detection falls back to resource probing.
 * Manifest verified against version 18.0.0.
 */
import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'bfogiafebfohielmmehodmfbbebbbpei';
export const keeper: ExtensionDefinition = {
  id: ID,
  name: "Keeper® Password Manager & Digital Vault",
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 2000000,
  notes: "A password manager exposing its autofill prompt UI to every origin, not just to sites it fills on.",
  signals: [
    { id: 'war-content-scripts-prompt-prompt-html', kind: 'web-accessible-resource',
      description: 'Fetch content_scripts/prompt/prompt.html, exposed to every origin.',
      weight: 1, run: () => probeFetch(ID, 'content_scripts/prompt/prompt.html') },
    { id: 'war-content-scripts-contextmenuconfirmation-', kind: 'web-accessible-resource',
      description: 'Fetch content_scripts/contextMenuConfirmation/contextMenuConfirmation.html, exposed to every origin.',
      weight: 0.5, run: () => probeFetch(ID, 'content_scripts/contextMenuConfirmation/contextMenuConfirmation.html') },
  ],
};
